import { useRef } from 'react';

import 'components/Payments/payroc/Payroc.scss';
import Label from 'components/Payments/payroc/components/Label';
import { usePayroc } from 'components/Payments/payroc/hooks/usePayroc';
import ErrorMessage from 'components/Payments/payroc/components/ErrorMessage';
import LoadingWrapper from 'components/Payments/payroc/components/LoadingWrapper';

const PayrocOnlineForm = ({
  id,
  amount,
  handlePayment,
  validate,
  children,
  buttonText,
  hideButton = false,
  mode,
  secureTokenId,
  onError,
  terminalPin,
  content
}) => {
  const containerRef = useRef(null);
  const { isLoading, error, retry } = usePayroc({
    id,
    amount,
    validate,
    type: 'card',
    containerRef,
    handlePayment,
    buttonText,
    hideButton,
    mode,
    secureTokenId,
    terminalPin,
    onError
  });

  return (
    <LoadingWrapper isLoading={isLoading} error={error} retry={retry} id={id}>
      <div
        ref={containerRef}
        className="card-container payroc-form flex h-full w-full flex-col items-center justify-center gap-2 p-1">
        <div className="flex w-full gap-3">
          <div className="flex w-full flex-col gap-1">
            <Label htmlFor="card-holder-name" required>
              Cardholder name
            </Label>
            <div className="card-holder-name-wrapper payment-input-wrapper">
              <div className="card-holder-name w-full" id="card-holder-name"></div>
            </div>
            <ErrorMessage className="card-holder-name-error" />
          </div>
          <div className="flex w-full flex-col gap-1">{content}</div>
        </div>
        {children}
        <div className="flex w-full gap-3 sm:flex-col">
          <div className="flex w-2/4 flex-col gap-1 sm:w-full">
            <Label htmlFor="card-number" required>
              Card number
            </Label>
            <div className="payment-input-wrapper card-number-wrapper">
              <div className="card-number w-full" id="card-number"></div>
            </div>
            <ErrorMessage className="card-number-error" />
          </div>
          <div className="flex w-1/4 flex-col gap-1 sm:w-full">
            <Label htmlFor="card-expiry" required>
              Expiration
            </Label>
            <div className="payment-input-wrapper card-expiry-wrapper">
              <div className="card-expiry w-full" id="card-expiry"></div>
            </div>
            <ErrorMessage className="card-expiry-error" />
          </div>
          <div className="flex w-1/4 flex-col gap-1 sm:w-full">
            <Label htmlFor="card-cvv" required>
              CVC
            </Label>
            <div className="payment-input-wrapper card-cvv-wrapper">
              <div className="card-cvv w-full" id="card-cvv"></div>
            </div>
            <ErrorMessage className="card-cvv-error" />
          </div>
        </div>
      </div>
    </LoadingWrapper>
  );
};

export default PayrocOnlineForm;
